import type { SVGProps } from 'react'

export const CheckVerifiedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    focusable={false}
    {...props}
  >
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M8.866 2.154a4.832 4.832 0 0 1 6.268 0c.454.387 1.018.62 1.612.668a4.832 4.832 0 0 1 4.432 4.432c.047.594.281 1.158.668 1.612a4.832 4.832 0 0 1 0 6.268 2.832 2.832 0 0 0-.668 1.612 4.832 4.832 0 0 1-4.432 4.432 2.832 2.832 0 0 0-1.612.668 4.832 4.832 0 0 1-6.268 0 2.832 2.832 0 0 0-1.612-.668 4.832 4.832 0 0 1-4.432-4.432 2.832 2.832 0 0 0-.668-1.612 4.832 4.832 0 0 1 0-6.268c.387-.454.62-1.018.668-1.612a4.832 4.832 0 0 1 4.432-4.432 2.832 2.832 0 0 0 1.612-.668Zm4.97 1.523a2.832 2.832 0 0 0-3.673 0 4.832 4.832 0 0 1-2.75 1.139 2.832 2.832 0 0 0-2.597 2.597 4.832 4.832 0 0 1-1.14 2.75 2.832 2.832 0 0 0 0 3.674 4.832 4.832 0 0 1 1.14 2.75 2.832 2.832 0 0 0 2.597 2.598c1.014.08 1.976.479 2.75 1.139a2.832 2.832 0 0 0 3.674 0 4.832 4.832 0 0 1 2.75-1.14 2.832 2.832 0 0 0 2.598-2.597 4.832 4.832 0 0 1 1.139-2.75 2.832 2.832 0 0 0 0-3.674 4.832 4.832 0 0 1-1.14-2.75 2.832 2.832 0 0 0-2.597-2.597 4.832 4.832 0 0 1-2.75-1.14Z"
        opacity={0.4}
      />
      <path d="M16.207 8.793a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.793-3.793a1 1 0 0 1 1.414 0Z" />
    </g>
  </svg>
)
